import { Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import { useState } from "react";
import Layout from "../../../components/dashboard/Layout";
import UserQRCode from "../../../containers/admin/students/models/user-qr-code";
import ActiveStudentsTable from "../../../containers/superadmin/students/active-table";
import AddStudent from "../../../containers/superadmin/students/models/add-student";
import ShowPassword from "../../../containers/superadmin/students/models/show-password";
import ResetPassword from "../../../containers/superadmin/students/models/reset-password";
import PendingStudentsTable from "../../../containers/superadmin/students/pending-table";
import SearchBar from "../../../containers/superadmin/students/searchbar";

const SuperadminStudents = () => {
  const [tab, setTab] = useState(0);

  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [addedStudent, setAddedStudent] = useState({});

  return (
    <Layout>
      <SearchBar
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        setSearchTerm={setSearchTerm}
        activeTab={tab}
      />
      <Tabs
        variant="soft-rounded"
        colorScheme="blue"
        py={5}
        onChange={(index) => setTab(index)}
        isFitted
      >
        <TabList mx={150} justifyContent="center">
          <Tab>الطلاب </Tab>
          <Tab>طلبات الطلاب</Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <ActiveStudentsTable
              setAdd={setAdd}
              setSelectedData={setSelectedData}
              searchTerm={searchTerm}
              tab={tab}
            />
          </TabPanel>
          <TabPanel>
            <PendingStudentsTable
              setAdd={setAdd}
              setSelectedData={setSelectedData}
              searchTerm={searchTerm}
              tab={tab}
            />
          </TabPanel>
        </TabPanels>
      </Tabs>
      <UserQRCode data={selectedData} setSelectedData={setSelectedData} />
      <AddStudent
        isAdd={isAdd}
        data={selectedData}
        setAddedStudent={setAddedStudent}
      />
      <ShowPassword data={addedStudent} />
      <ResetPassword />
    </Layout>
  );
};

export default SuperadminStudents;
